import { useInfiniteReactionsQuery } from "@/hooks/useInfiniteReactionsQuery";
import type { PaginatedReactionResponse } from "@/lib/humhub-api/types";

interface UsePaginatedReactionsOptions<TQueryKey extends readonly unknown[]> {
  queryKey: TQueryKey;
  enabled: boolean;
  hasTarget: boolean;
  missingTargetError: string;
  fetchPage: (page: number) => Promise<PaginatedReactionResponse>;
}

export const usePaginatedReactions = <TQueryKey extends readonly unknown[]>({
  queryKey,
  enabled,
  hasTarget,
  missingTargetError,
  fetchPage,
}: UsePaginatedReactionsOptions<TQueryKey>) => {
  return useInfiniteReactionsQuery({
    queryKey,
    queryFn: async (page) => {
      if (!hasTarget) {
        throw new Error(missingTargetError);
      }
      return await fetchPage(page);
    },
    enabled: hasTarget && enabled,
  });
};
